import { createContext, useContext } from 'react';

// What every builder panel needs, provided once by the page (index.js):
//   state, dispatch            the builder reducer (state/builderReducer.js)
//   readOnly                   archived form: no edits
//   layout                     useBuilderLayout() result
//   assetUrls                  { [assetId]: url } (server + not-yet-saved)
//   uploadAsset(file)          → Promise<assetId | null>; toasts failures
//   uploading                  an upload is in flight
//   showToast(toast)
//   savedFields, removeSavedField(saved), saveFieldForReuse(field)
//   venues                     [{ id, name }] for the account select
//   accountName                the working account's name
//   onDuplicateForm(), onArchiveForm()
//   kind                       'custom' | 'w9' (state.kind)
//   lockedFieldIds             state.lockedFieldIds (w9-plan §6.5; [] on a
//                              regular form)
//   isLocked(id)               → true for a locked field
const BuilderContext = createContext(null);

export const useBuilder = () => useContext(BuilderContext);

export default BuilderContext;
